import ReportDialog from "./ReportDialog";

export default ReportDialog;
